"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.ProductInfoItem = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _Core = require("../../components/Core");

var _styled = require("../../styles/styled");

var _class;

var ProductInfoItem = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(ProductInfoItem, _Component);

  function ProductInfoItem(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = ProductInfoItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        info = _this$props.info;
    return _react.default.createElement(InfoWrapper, {
      flexDirection: "column",
      justifyContent: "start",
      p: 1
    }, _react.default.createElement("h4", {
      style: {
        textDecoration: "underline"
      }
    }, label), _react.default.createElement("span", null, info));
  };

  return ProductInfoItem;
}(_react.Component)) || _class;

exports.ProductInfoItem = ProductInfoItem;
var InfoWrapper = (0, _styled.styled)(_Core.Flex).withConfig({
  componentId: "sc-1nrqbn5-0"
})(["flex:0 0 200px;"]);